<template>
    <Breadcrumb :items="breadcrumbs" />
    <div class="container-fluid my-3">

        <div class="d-flex justify-content-between align-items-center mb-4">
            <h4 class="mb-0">
                <i class="pi pi-file-edit me-2"></i>
                قوالب رسائل واتساب
            </h4>
        </div>

        <div v-if="loading" class="text-center py-5">
            <i class="pi pi-spin pi-spinner" style="font-size:2rem"></i>
        </div>

        <div v-else class="row">
            <div v-for="template in templates" :key="template.id" class="col-xl-6 col-lg-12 mb-4">
                <div class="card h-100">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h6 class="mb-0 fw-bold">{{ template.name }}</h6>
                        <div class="form-check form-switch mb-0 d-flex align-items-center gap-2">
                            <input class="form-check-input" type="checkbox" :id="'active-' + template.id"
                                v-model="template.is_active" />
                            <label class="form-check-label" :for="'active-' + template.id">
                                {{ template.is_active ? 'مفعّل' : 'معطّل' }}
                            </label>
                        </div>
                    </div>
                    <div class="card-body d-flex flex-column">
                        <div class="mb-2">
                            <small class="text-muted">الكود: <code class="ms-1">{{ template.code }}</code></small>
                        </div>
                        <Textarea v-model="template.message" style="display:block;width:100%;font-family:inherit;direction:rtl"
                            :rows="6" class="mb-2" />
                        <div class="text-muted small mb-3">
                            المتغيرات المتاحة:
                            <span v-for="v in variables" :key="v" class="badge bg-secondary ms-1 mb-1" style="font-size:0.7rem;direction:ltr">
                                {{ wrapVar(v) }}
                            </span>
                        </div>
                        <button class="btn btn-primary mt-auto" @click="saveTemplate(template)" :disabled="template.saving">
                            <i class="pi pi-save me-1"></i>
                            {{ template.saving ? 'جاري الحفظ...' : 'حفظ التغييرات' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!loading && templates.length === 0" class="alert alert-warning">
            لا توجد قوالب مسجّلة.
        </div>

    </div>
</template>

<script>
import axios from 'axios';
import Textarea from 'primevue/textarea';
import Swal from 'sweetalert2';
import Breadcrumb from '@/components/global/breadcrumb.vue';

export default {
    name: 'WhatsAppTemplatesSettings',
    components: { Textarea, Breadcrumb },

    data() {
        return {
            templates: [],
            loading: true,
            variables: [
                'student_name', 'parent_name', 'parent_phone',
                'date', 'time', 'academic_year',
                'fee_name', 'fee_amount',
                'teacher_name', 'attendance_status',
            ],
            breadcrumbs: [
                { name: 'الرئيسية', path: '/' },
                { name: 'الإعدادات', path: '/' },
                { name: 'قوالب واتساب', path: '/settings/whatsapp-templates' },
            ],
        };
    },

    methods: {
        wrapVar(v) { return '{' + '{' + v + '}' + '}'; },

        async fetchTemplates() {
            this.loading = true;
            try {
                const res = await axios.get('/whatsapp-templates');
                this.templates = (res.data.data ?? []).map(t => ({ ...t, saving: false }));
            } catch {
                Swal.fire({ icon: 'error', title: 'خطأ', text: 'تعذّر تحميل القوالب', timer: 2500, showConfirmButton: false });
            } finally {
                this.loading = false;
            }
        },

        async saveTemplate(template) {
            template.saving = true;
            try {
                await axios.put(`/whatsapp-templates/${template.id}`, {
                    name:      template.name,
                    message:   template.message,
                    is_active: template.is_active,
                });
                Swal.mixin({
                    toast: true, position: 'top-end',
                    showConfirmButton: false, timer: 2000, timerProgressBar: true,
                }).fire({ icon: 'success', title: 'تم حفظ القالب' });
            } catch {
                Swal.fire({ icon: 'error', title: 'خطأ', text: 'فشل حفظ القالب', timer: 2500, showConfirmButton: false });
            } finally {
                template.saving = false;
            }
        },
    },

    mounted() {
        this.fetchTemplates();
    },
};
</script>
